import { useEffect } from 'react';

// Adds `is-visible` to every [data-reveal] element once it scrolls into view.
// The fade-up styles live in global.css and are skipped for reduced motion.
export function useReveal(deps: unknown[] = []) {
  useEffect(() => {
    const els = Array.from(document.querySelectorAll<HTMLElement>('[data-reveal]:not(.is-visible)'));
    if (!('IntersectionObserver' in window)) {
      els.forEach((el) => el.classList.add('is-visible'));
      return;
    }
    // Anything already on screen shows right away (next frame, so it still fades in)
    const below: HTMLElement[] = [];
    const frame = requestAnimationFrame(() => {
      els.forEach((el) => {
        if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('is-visible');
      });
    });
    els.forEach((el) => {
      if (el.getBoundingClientRect().top >= window.innerHeight) below.push(el);
    });
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );
    below.forEach((el) => io.observe(el));
    return () => {
      cancelAnimationFrame(frame);
      io.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
